// src/pages/SubscriptionExpired.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const SubscriptionExpired = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
      <h1 className="text-3xl font-bold text-red-600 mb-4">Subscription expired</h1>
      <p className="text-gray-700 text-center mb-6">
      Your access period has ended. Please renew your subscription to continue using the app.
      </p>
      {/* <Link
        to="/abonnement"
        className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
      >
        Renew now
      </Link> */}
    </div>
  );
};

export default SubscriptionExpired;
